import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Consulta } from "../constants";
import { consultivoFiltroSelector } from "./consultivoFiltro";

const initialState = {
  filtro: {
    statusIds: [
      Consulta.Status.Cadastro.id,
      Consulta.Status.Aberto.id,
      Consulta.Status.EmTrabalho.id,
      Consulta.Status.AguardandoDocumentos.id,
      Consulta.Status.Pausado.id,
    ],
    emAtraso: true
  },

  consultasPorStatus: {},
  consultas: [],
};

export const filtroSelector = state => state.consultivoOperacional.filtro;
export const consultasPorStatusSelector = state => state.consultivoOperacional.consultasPorStatus;
export const consultasSelector = state => state.consultivoOperacional.consultas;

export const fetchConsultasPorStatus = createAsyncThunk(
  'consultivoOperacional/fetchConsultasPorStatus',
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const filtro = { ...consultivoFiltroSelector(state), ...filtroSelector(state) };
      const { data } = await axios.get('/consultivo/operacional/consultas-por-status', { params: filtro });
      return data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const fetchConsultas = createAsyncThunk(
  'consultivoOperacional/fetchConsultas',
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const filtro = { ...consultivoFiltroSelector(state), ...filtroSelector(state) };
      const { data } = await axios.get('/consultivo/operacional/consultas', { params: filtro });
      return data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const slice = createSlice({
  name: 'consultivoOperacional',
  initialState,
  reducers: {
    resetar: (state) => {
      return initialState;
    },
    filtrar: (state, action) => {
      state.filtro = { ...state.filtro, ...action.payload };
    }
  },
  extraReducers: {
    [fetchConsultasPorStatus.fulfilled]: (state, action) => {
      state.consultasPorStatus = action.payload;
    },
    [fetchConsultas.fulfilled]: (state, action) => {
      state.consultas = action.payload;
    }
  },
});

export default slice.reducer;

export const { resetar, filtrar } = slice.actions;
